<template>
  <div>
    <div class="d-flex align-end justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">ติดตามความก้าวหน้าแบบ S-curve</div>
        <div class="d-flex align-center">
          <Iconify
            icon="ion:document-text"
            color="var(--theme-color-one)"
            class="mr-3"
          ></Iconify>
          <div class="font-type-bold txt-head black--text">
            รายงานผลการดำเนินการ
          </div>
        </div>
      </div>

      <Button theme="7" @onClick="exportProgressExcel"> Export Excel </Button>
    </div>

    <divcard class="mb-5" v-if="!isOIC">
      <v-form ref="form" v-model="valid" lazy-validation>
        <div class="d-flex align-center">
          <div class="black--text txt-m-head mb-3">
            ขยายเวลาการกรอกผลการติดตามรายเดือน
          </div>
          <Iconify
            icon="material-symbols:edit"
            color="var(--theme-color-seven)"
            class="ml-3"
          ></Iconify>
        </div>
        <v-row class="px-6 pt-4">
          <v-col cols="12" class="py-0">
            <!--            radio select between form c, form d, form f then dropdown will changed by select radio-->
            <v-radio-group
              v-model="form.form_type"
              row
              label="ประเภทโครงการย่อย"
              @change="form.form_c_id = ''"
            >
              <v-radio
                label="แบบฟอร์มยื่นข้อเสนอโครงการ (USP) (Form C)"
                value="c"
                color="var(--theme-color-one)"
              ></v-radio>
              <v-radio
                label="แผนงานบริหารจัดการอาคาร (Form D)"
                value="d"
                color="var(--theme-color-one)"
              ></v-radio>
              <v-radio
                label="แผนงาน RSP Management (Form F)"
                value="f"
                color="var(--theme-color-one)"
              ></v-radio>
            </v-radio-group>
            <label class="mb-1 black--text">
              โครงการย่อย<span style="color: #f15a29">*</span>
            </label>
            <v-autocomplete
              v-model="form.form_c_id"
              :items="
                form.form_type === 'd'
                  ? formD
                  : form.form_type === 'f'
                  ? formF
                  : form.form_type === 'c'
                  ? formC
                  : []
              "
              item-text="name"
              item-value="id"
              outlined
              dense
              class="mt-2"
              style="border-radius: 30px"
              color="#F7941D"
              placeholder="โครงการย่อย"
              :rules="[(v) => !!v || 'กรุณาระบุโครงการย่อย']"
              required
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row class="px-6 pt-4">
          <v-col cols="6" class="py-0 px-3">
            <div class="mb-1 black--text">ปีพ.ศ.</div>
            <SelectBox
              theme="3"
              placeholder="ปีพ.ศ."
              hide-details
              dense
              :items="yearList"
              @onChange="form.extend_year = $event"
              :rules="[(v) => !!v || 'กรุณาระบุปีพ.ศ.']"
            ></SelectBox>
          </v-col>
          <v-col cols="6" class="py-0">
            <div class="mb-1 black--text">เดือน</div>
            <SelectBox
              theme="3"
              placeholder="เดือน"
              item-text="name"
              item-value="value"
              dense
              :items="monthList"
              @onChange="form.extend_month = $event"
              :rules="[(v) => !!v || 'กรุณาระบุเดือน']"
              class="px-2"
            ></SelectBox>
          </v-col>
        </v-row>

        <v-row class="px-6 pt-4">
          <v-col cols="6" class="py-0">
            <div class="mb-1 black--text">วันที่มีผล</div>
            <DatePicker
              :value="form.extend_date"
              :minDate="today"
              :maxDate="projectEndDate"
              placeholder="วันที่มีผล"
              @onInput="
                form.extend_date = $event;
                $forceUpdate();
              "
              :rules="[(v) => !!v || 'กรุณาระบุวันที่มีผล']"
            ></DatePicker>
          </v-col>
          <v-col cols="6" class="py-0">
            <div class="mb-1 black--text">วันที่สิ้นสุด</div>
            <DatePicker
              :value="form.expiration_date"
              :minDate="projectStartDate"
              placeholder="วันที่สิ้นสุด"
              @onInput="
                form.expiration_date = $event;
                $forceUpdate();
              "
              :rules="[(v) => !!v || 'กรุณาระบุวันที่สิ้นสุด']"
            ></DatePicker>
          </v-col>
        </v-row>
      </v-form>

      <v-layout justify-end align-center mt-6>
        <v-flex shrink mr-4>
          <v-btn
            width="100"
            height="35"
            depressed
            rounded
            color="#D9D9D9"
            @click="resetForm"
          >
            <span class="font-14 font-w-700 font-ch">ยกเลิก</span>
          </v-btn>
        </v-flex>
        <v-flex shrink>
          <v-btn
            width="100"
            height="35"
            dark
            rounded
            class="btn_gradient"
            @click="onSubmit"
          >
            <span class="font-14 font-w-700 font-ch">บันทึก</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </divcard>

    <div class="px-5">
      <divcard v-for="(team, i) in teams" :key="i" class="mb-3">
        <div class="black--text txt-m-head mb-3">1.{{ i + 1 }} ข้อมูลคณะ</div>
        <v-btn icon absolute top right style="z-index: 99" @click="delTeam(i)">
          <Iconify class="font-18" style="color: #b1b1b1" icon="mdi:delete" />
        </v-btn>
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">ชื่อ - สกุล</div>
            <TextField
              theme="3"
              :value="team.s2_p1_name"
              @onChange="setTeamField('s2_p1_name', i, $event)"
            ></TextField>
          </div>
          <div class="flex xs6">
            <div class="mb-1 black--text">ตำเเหน่ง</div>
            <AutoBox
              theme="3"
              :items="masterData.positions"
              item-text="name"
              item-value="name"
              :value="team.s2_p1_position"
              @onChange="setTeamField('s2_p1_position', i, $event)"
            ></AutoBox>
          </div>
        </div>

        <!-- Form 1 #line2 -->
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">หน่วยงาน</div>
            <AutoBox
              theme="3"
              :items="masterData.institutes"
              item-text="name"
              item-value="name"
              :value="team.s2_p1_dep"
              @onChange="setTeamField('s2_p1_dep', i, $event)"
            ></AutoBox>
          </div>
          <div class="flex xs6">
            <div class="mb-1 black--text">สังกัด</div>
            <TextField
              theme="3"
              :value="team.s2_p1_org"
              @onChange="setTeamField('s2_p1_org', i, $event)"
            ></TextField>
          </div>
        </div>

        <!-- Form 1 #line3 -->
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">ที่อยู่</div>
            <TextField
              theme="3"
              :value="team.s2_p1_addr"
              @onChange="setTeamField('s2_p1_addr', i, $event)"
            ></TextField>
          </div>
          <div class="flex xs6">
            <div class="flex-center gap-16">
              <div class="flex xs6">
                <div class="mb-1 black--text">เบอร์โทรศัพท์</div>
                <TextField
                  placeholder="09XXXXXXXX"
                  theme="3"
                  input-type="number"
                  :value="team.s2_p1_phone"
                  @onChange="setTeamField('s2_p1_phone', i, $event)"
                ></TextField>
              </div>
              <div class="flex xs6">
                <div class="mb-1 black--text">E-mail</div>
                <TextField
                  theme="3"
                  :rules="emailRules"
                  :value="team.s2_p1_email"
                  @onChange="setTeamField('s2_p1_email', i, $event)"
                ></TextField>
              </div>
            </div>
          </div>
        </div>

        <!-- Form 1 #line4 -->
        <div class="flex-center gap-16">
          <div class="flex xs6">
            <div class="mb-1 black--text">ความเชี่ยวชาญ</div>
            <TextField
              theme="3"
              :value="team.s2_p1_expertise"
              @onChange="setTeamField('s2_p1_expertise', i, $event)"
            ></TextField>
          </div>
          <div class="flex xs6">
            <div class="flex-center gap-16">
              <div class="flex xs6">
                <div class="mb-1 black--text">สัดส่วนการทำงาน</div>
                <TextField
                  theme="3"
                  :value="team.s2_p1_resp"
                  @onChange="setTeamField('s2_p1_resp', i, $event)"
                ></TextField>
              </div>
              <div class="flex xs6">
                <div class="mb-1 black--text">ชั่วโมงการทำงาน</div>
                <TextField
                  theme="3"
                  :value="team.s2_p1_resp_hrs"
                  @onChange="setTeamField('s2_p1_resp_hrs', i, $event)"
                ></TextField>
              </div>
            </div>
          </div>
        </div>
      </divcard>
    </div>

    <div class="d-flex gap-24 mb-5">
      <div class="flex-center">
        <div class="font-type-bold text-no-wrap">โครงการหลัก</div>
        <AutoBox
          placeholder="โครงการหลัก"
          hide-details
          :items="masterData.main_project_list"
          :value="masterData.main_project_id"
          item-text="name"
          item-value="id"
          clearable
          @onChange="
            masterData.main_project_id = $event;
            getProgress();
          "
        ></AutoBox>
      </div>

      <div class="flex-center">
        <div class="font-type-bold text-no-wrap">ภูมิภาค</div>
        <SelectBox
          placeholder="ภูมิภาค"
          hide-details
          style="max-width: 160px"
          :items="masterData.region_masters"
          :value="
            userInfo.user_type !== 'สป.อว.'
              ? parseInt(masterData.region_id)
              : null
          "
          item-text="name"
          item-value="id"
          clearable
          :disabled="userInfo.user_type === 'RSP'"
          @onChange="
            masterData.region_id = $event;
            getProgress();
          "
        ></SelectBox>

        <!-- <SelectBox
            placeholder="ภูมิภาค"
            hide-details
            style="max-width: 160px"
            :items="masterData.region_masters"
            :value="parseInt(masterData.region_id)"
            item-text="name"
            item-value="id"
            clearable
            :disabled="userInfo.user_type === 'RSP'"
            @onChange="masterData.region_id = $event; getProgress()"
        ></SelectBox> -->
      </div>

      <div class="flex-center">
        <div class="font-type-bold text-no-wrap">แผนงาน</div>
        <AutoBox
          placeholder="แผนงาน"
          hide-details
          :items="masterData.plan_masters"
          :value="masterData.plan_master_id"
          item-text="plan_name_th"
          item-value="id"
          clearable
          @onChange="
            masterData.plan_master_id = $event;
            getProgress();
          "
        ></AutoBox>
      </div>

      <div class="flex-center">
        <div class="font-type-bold text-no-wrap">ปี งปม.</div>
        <SelectBox
          placeholder="ปี งปม."
          hide-details
          :items="yearList"
          :value="masterData.fiscal_year"
          item-text="plan_name_th"
          item-value="id"
          style="max-width: 160px"
          @onChange="
            masterData.fiscal_year = $event;
            getProgress();
          "
        ></SelectBox>
      </div>
    </div>
    <divcard class="d-flex justify-space-between mb-2" style="gap: 12px">
      <div
        class="d-flex flex-column"
        style="min-width: 10%; max-width: 10%; gap: 10px"
      >
        <div>แผนงาน</div>
        <div>ปี งปม.</div>
      </div>

      <div
        class="d-flex flex-column"
        style="min-width: 70%; max-width: 70%; gap: 10px"
      >
        <div>{{ selectedPlanLabel }}</div>
        <div>{{ masterData.fiscal_year }}</div>
      </div>

      <Button @onClick="ToScurve()" style="min-width: 10%; max-width: 10%">
        {{ isScurve ? "กลับหน้าเดิม" : "S-curve" }}
      </Button>
    </divcard>

    <!--    <divcard class="d-flex flex-column gap-8 mb-5">-->
    <!--      <div class="d-flex gap-8">-->
    <!--        <div class="black&#45;&#45;text font-type-bold" style="min-width: 140px; max-width: 140px">แผนงาน</div>-->
    <!--        <div>-->
    <!--          {{ masterData.plan_name }}-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="d-flex gap-8">-->
    <!--        <div class="black&#45;&#45;text font-type-bold" style="min-width: 140px; max-width: 140px">ปี งปม.</div>-->
    <!--        <div>-->
    <!--          {{ masterData.fiscal_year }}-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </divcard>-->

    <div class="d-flex justify-end my-8">
      <v-btn
        width="100"
        height="35"
        dark
        rounded
        class="btn_gradient mr-5"
        @click="expandAll"
      >
        <span class="font-14 font-w-500 font-ch">Expand All</span>
      </v-btn>
      <v-btn
        width="100"
        height="35"
        dark
        rounded
        class="btn_gradient"
        @click="collapseAll"
      >
        <span class="font-14 font-w-500 font-ch">Collapse All</span>
      </v-btn>
    </div>

    <divcard
      v-for="(region, i) in regions"
      :key="i"
      class="d-flex flex-column gap-8 mb-5"
    >
      <div
        class="d-flex justify-space-between align-center"
        style="min-height: 38px"
      >
        <div class="black--text font-type-bold">
          {{ region.name }}
        </div>

        <!-- expand & collapse icon -->
        <v-btn
          icon
          :class="{ rotate180: regionExpanded[i] }"
          @click="toggleRegion(i)"
        >
          <Iconify
            icon="material-symbols:keyboard-arrow-down"
            color="#D3D3D3"
          ></Iconify>
        </v-btn>
      </div>
      <div
        class="d-flex justify-end align-center"
        style="min-height: 38px"
        v-if="regionExpanded[i] && isScurve"
      >
        <SelectBox
          v-show="isScurve"
          placeholder="โปรดระบุ"
          hide-details
          :items="seriesNames"
          :value="selectedFilter"
          class="custom-selectbox-chart"
          @onChange="
            selectedFilter = $event || 'all';
            activeSeriesNames = !$event || $event === 'all' ? masterSeries.map(s => s.name) : [$event];
            applyFilter();
          "
        ></SelectBox>
      </div>
      <div v-if="isScurve" class="py-5" v-show="regionExpanded[i]">
        <div class="chart-container">
          <highcharts :options="chartOptionByRegion(region.name)"></highcharts>

          <div class="custom-legend">
            <span
              v-for="(item, index) in legendSeries"
              :key="index"
              :class="{ 'legend-inactive': !activeSeriesNames.includes(item.name) }"
              :style="{
                background: activeSeriesNames.includes(item.name) ? item.color : '#B0B0B0',
                margin: '0 10px',
                cursor: 'pointer',
              }"
              @click="toggleSeries(item.name)"
            >
              {{ item.name }}
            </span>
          </div>
        </div>
      </div>
      <div
        v-else
        class="py-5 overflow-x-auto mx-n6 px-6 scroll"
        v-show="regionExpanded[i]"
      >
        <div class="d-flex align-center gap-8 px-3 mb-3">
          <div class="flex" style="min-width: 30px; max-width: 30px"></div>
          <div class="flex" style="min-width: 120px; max-width: 120px">
            โครงการ
          </div>
          <div
            class="flex text-center"
            style="min-width: 61px; max-width: 61px"
          >
            WF
          </div>
          <div
            v-for="(m, ind) in region.yearMonthList"
            :key="ind"
            class="flex"
            :class="{ 'extended-month-header': isExtendedMonth(ind) }"
            style="min-width: 43px; max-width: 43px"
          >
            <div class="text-center">{{ m.month_th }}</div>
            <div class="text-center">{{ m.year_th }}</div>
          </div>
          <div class="flex" style="min-width: 43px; max-width: 43px">แผนผล</div>
          <div
            class="flex text-center"
            style="min-width: 43px; max-width: 43px"
          >
            %
          </div>
          <div
            class="flex text-center"
            style="min-width: 120px; max-width: 120px"
          >
            ผู้รับผิดชอบ
          </div>
          <div
            class="flex text-center"
            style="min-width: 120px; max-width: 120px"
          >
            คำชี้แจง
          </div>
          <template v-if="userInfo.user_type === 'สป.อว.'">
            <div
              class="flex text-center"
              style="min-width: 120px; max-width: 120px"
            >
              ผู้รับผิดชอบ สป.อว.
            </div>
            <div
              class="flex text-center"
              style="min-width: 120px; max-width: 120px"
            >
              คำชี้แจง สป.อว.
            </div>
          </template>
        </div>
        <!--   PLAN ITEMS   -->
        <div
          v-if="region.form_c_list && region.form_c_list.length > 0"
          class="d-flex flex-column gap-12"
        >
          <div
            v-for="(item, c_i) in region.form_c_list"
            :key="c_i"
            class="plan-card d-flex gap-8"
          >
            <div class="flex" style="min-width: 30px; max-width: 30px"></div>
            <div
              class="flex two-line"
              style="min-width: 120px; max-width: 120px; max-height: 45px"
            >
              {{
                item?.project_section_general_info?.project_name_th ??
                item?.project_section_general_info?.lab_name ??
                item?.form_a?.main_project.name
              }}
            </div>
            <div
              class="flex d-flex justify-space-between"
              style="min-width: 61px; max-width: 61px; height: 54px"
            >
              <v-divider vertical></v-divider>
              <div
                class="tiny-field tf-active"
                style="min-width: 40px; max-width: 40px; height: 100%"
              >
                {{ formatNumber(item.wf, 2) }}
              </div>
              <v-divider vertical></v-divider>
            </div>
            <div
              v-for="(m, m_i) in item.project_section_plan_p1_budget"
              :key="m_i"
              class="flex d-flex flex-column gap-8"
              :class="{
                'extended-month-bg': isExtendedMonth(m_i),
              }"
              style="min-width: 43px; max-width: 43px"
            >
              <div
                class="tiny-field"
                :class="{
                  'extended-month-cell':
                    isExtendedMonth(m_i) &&
                    m.month_value !== null &&
                    m.month_value !== undefined &&
                    m.month_value !== '' &&
                    m.month_value !== 0,
                }"
              >
                {{ m.month_value ? formatNumber(m.month_value, 2) : "-" }}
              </div>
              <div
                class="tiny-field"
                :class="{
                  'extended-month-cell':
                    isExtendedMonth(m_i) &&
                    m.actual_month_value !== null &&
                    m.actual_month_value !== undefined &&
                    m.actual_month_value !== '' &&
                    m.actual_month_value !== 0,
                  'correct-range-cell': isInCorrectRange(
                    region.yearMonthList[m_i]
                  ),
                }"
              >
                {{
                  m.actual_month_value
                    ? formatNumber(m.actual_month_value, 2)
                    : "-"
                }}
              </div>
            </div>

            <div
              class="flex d-flex flex-column gap-8"
              style="min-width: 43px; max-width: 43px"
            >
              <div class="tiny-field">
                {{ formatNumber(item.plan, 2) }}
              </div>
              <div class="tiny-field">
                {{ formatNumber(item.result, 2) }}
              </div>
            </div>

            <div
              class="flex d-flex flex-column gap-8"
              style="min-width: 43px; max-width: 43px"
            >
              <div class="tiny-field">
                {{ formatNumber(item.percent, 2) }}
              </div>
              <div class="tiny-field">
                {{
                  formatNumber((item.plan > 0 ? (parseFloat((item.result * 100) / item.plan)) : 0), 2)
                }}
              </div>
            </div>

            <!-- Section 1: ผู้รับผิดชอบ -->
            <div
              class="flex d-flex flex-column gap-8"
              style="min-width: 120px; max-width: 120px"
            >
              <div
                :class="
                  getResponsibleStatus(item)
                    ? 'progress-followed-add-field'
                    : 'tiny-field'
                "
                :style="!getResponsibleStatus(item) ? 'height: auto; overflow: hidden; width: 100%;' : ''"
                @click="openResponsibleModal(item)"
              >
                <div v-if="getResponsibleStatus(item)">
                  <v-icon size="16px" color="white">mdi-account-plus-outline</v-icon>
                </div>
                <div v-else style="width: 100%;">
                  <div
                    v-for="(person, pi) in getRspTakers(item)"
                    :key="pi"
                    class="d-flex align-center text-theme-1 text-underline cursor-pointer"
                    style="width: 100%;"
                  >
                    <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex: 1; min-width: 0;">
                      {{ person.taker }}
                    </div>
                    <span v-if="person.hours" class="ml-1 flex-shrink-0">
                      ({{ formatHours(person.hours) }})
                    </span>
                  </div>
                </div>
              </div>
              <!-- <div
                :class="
                  getResponsibleStatus(item)
                    ? 'progress-followed-add-field'
                    : 'tiny-field'
                "
                @click="openResponsibleModal(item)"
              >
                <div v-if="getResponsibleStatus(item)">
                  <v-icon size="10px" color="white">mdi-plus</v-icon>
                  เพิ่มผู้รับผิดชอบ
                </div>
                <div v-else class="d-flex align-center justify-space-between">
                  <div
                    class="text-theme-1 text-underline cursor-pointer"
                    style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 85px"
                  >
                    {{ getResponsibleDisplayValue(item) }}
                  </div>
                  <v-icon
                    size="12px"
                    color="#b1b1b1"
                    class="ml-1 cursor-pointer"
                    @click.stop="openDeleteModal(item, 'responsible')"
                  >
                    mdi-delete
                  </v-icon>
                </div>
              </div> -->
            </div>

            <!-- Section 2: คำชี้แจง -->
            <div
              class="flex d-flex flex-column gap-8"
              style="min-width: 120px; max-width: 120px"
            >
              <div
                :class="
                  getExplanationStatus(item)
                    ? 'progress-followed-add-field'
                    : 'tiny-field'
                "
                @click="openExplanationModal(item)"
              >
                <div v-if="getExplanationStatus(item)">
                  <v-icon size="16px" color="white">mdi-comment-plus-outline</v-icon>
                </div>
                <div v-else class="d-flex align-center justify-space-between">
                  <div class="text-theme-1 cursor-pointer">รายละเอียด</div>
                  <v-icon
                    v-if="userInfo.user_type !== 'สป.อว.'"
                    size="12px"
                    color="#b1b1b1"
                    class="ml-1 cursor-pointer"
                    @click.stop="openDeleteModal(item, 'explanation')"
                  >
                    mdi-delete
                  </v-icon>
                </div>
              </div>
              <!-- <div
                :class="
                  getExplanationStatus(item)
                    ? 'progress-followed-add-field'
                    : 'tiny-field'
                "
                @click="openExplanationModal(item)"
              >
                <div v-if="getExplanationStatus(item)">
                  <v-icon size="10px" color="white">mdi-plus</v-icon>
                  เพิ่มคำชี้แจง
                </div>
                <div v-else class="d-flex align-center justify-space-between">
                  <div class="text-theme-1 cursor-pointer">รายละเอียด</div>
                  <v-icon
                    size="12px"
                    color="#b1b1b1"
                    class="ml-1 cursor-pointer"
                    @click.stop="openDeleteModal(item, 'explanation')"
                  >
                    mdi-delete
                  </v-icon>
                </div>
              </div> -->
            </div>

            <!-- Section 3: ผู้รับผิดชอบ สป.อว. -->
            <template v-if="userInfo.user_type === 'สป.อว.'">
              <div
                class="flex d-flex flex-column gap-8"
                style="min-width: 120px; max-width: 120px"
              >
                <div
                  :class="getResponsibleStatusSP(item) ? 'progress-followed-add-field' : 'tiny-field'"
                  :style="!getResponsibleStatusSP(item) ? 'height: auto; overflow: hidden; width: 100%;' : ''"
                  @click="openResponsibleModal(item, 'สป.อว.')"
                >
                  <div v-if="getResponsibleStatusSP(item)">
                    <v-icon size="16px" color="white">mdi-account-plus-outline</v-icon>
                  </div>
                  <div v-else style="width: 100%;">
                    <div
                      v-for="(person, pi) in getSpTakers(item)"
                      :key="pi"
                      class="d-flex align-center text-theme-1 text-underline cursor-pointer"
                      style="width: 100%;"
                    >
                      <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex: 1; min-width: 0;">
                        {{ person.taker }}
                      </div>
                      <span v-if="person.hours" class="ml-1 flex-shrink-0">
                        ({{ formatHours(person.hours) }})
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Section 4: คำชี้แจง สป.อว. -->
              <div
                class="flex d-flex flex-column gap-8"
                style="min-width: 120px; max-width: 120px"
              >
                <div
                  :class="getExplanationStatusSP(item) ? 'progress-followed-add-field' : 'tiny-field'"
                  @click="openExplanationModal(item, 'สป.อว.')"
                >
                  <div v-if="getExplanationStatusSP(item)">
                    <v-icon size="16px" color="white">mdi-comment-plus-outline</v-icon>
                  </div>
                  <div v-else class="d-flex align-center justify-space-between">
                    <div class="text-theme-1 cursor-pointer">รายละเอียด</div>
                    <v-icon
                      size="12px"
                      color="#b1b1b1"
                      class="ml-1 cursor-pointer"
                      @click.stop="openDeleteModal(item, 'explanation_sp')"
                    >
                      mdi-delete
                    </v-icon>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <!--   SUMMARY   -->
          <div class="plan-card">
            <div class="d-flex gap-8">
              <div class="flex" style="min-width: 30px; max-width: 30px"></div>
              <div class="flex" style="min-width: 120px; max-width: 120px">
                แผนงานถ่วงน้ำหนัก
              </div>
              <div
                class="flex d-flex justify-space-between"
                style="min-width: 61px; max-width: 61px"
              >
                <v-divider vertical></v-divider>
                <div
                  class="tiny-field"
                  :class="{
                    'theme-color-four tf-error':
                      totalWF(region.form_c_list) !== '1.00',
                  }"
                  style="min-width: 40px; max-width: 40px"
                >
                  {{ totalWF(region.form_c_list) }}
                </div>
                <v-divider vertical></v-divider>
              </div>

              <div
                v-for="(m, ym_i) in region.yearMonthList"
                :key="ym_i"
                class="flex"
                style="min-width: 43px; max-width: 43px"
              >
                <div v-if="isInCorrectRange(m)">
                  <div class="tiny-field">
                    {{ weightPlan(region.form_c_list, ym_i) }}
                  </div>
                </div>
                <div v-else>
                  <div class="tiny-field">
                    {{ weightPlan(region.form_c_list, ym_i) }}
                  </div>
                </div>
              </div>

              <div
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{ weightActivePlan(region.form_c_list) }}
              </div>
              <div
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{ weightActivePlanPercent(region.form_c_list) }}
              </div>
              <div style="min-width: 120px; max-width: 120px"></div>
              <div style="min-width: 120px; max-width: 120px"></div>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="d-flex gap-8">
              <div class="flex" style="min-width: 30px; max-width: 30px"></div>
              <div class="flex" style="min-width: 120px; max-width: 120px">
                ผลการดำเนินงาน
              </div>
              <div
                class="flex d-flex justify-space-between"
                style="min-width: 61px; max-width: 61px"
              >
                <v-divider vertical></v-divider>
                <div style="min-width: 40px; max-width: 40px"></div>
                <v-divider vertical></v-divider>
              </div>
              <div
                v-for="(m, ym_ind) in region.yearMonthList"
                :key="ym_ind"
                class="flex"
                style="min-width: 43px; max-width: 43px"
              >
                <div v-if="isInCorrectRange(m)">
                  <div class="tiny-field">
                    {{ resultPlan(region.form_c_list, ym_ind) }}
                  </div>
                </div>
                <div v-else>
                  <div class="tiny-field">
                    {{ resultPlan(region.form_c_list, ym_ind) }}
                  </div>
                </div>
              </div>
              <div
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{ weightActiveResult(region.form_c_list) }}
              </div>
              <div
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{
                  formatNumber(
                    parseFloat(
                      (weightActiveResult(region.form_c_list) * 100) /
                        weightActivePlan(region.form_c_list)
                    ),
                    2
                  )
                }}
              </div>
              <div style="min-width: 120px; max-width: 120px"></div>
              <div style="min-width: 120px; max-width: 120px"></div>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="d-flex gap-8">
              <div class="flex" style="min-width: 30px; max-width: 30px"></div>
              <div class="flex" style="min-width: 120px; max-width: 120px">
                แผนการใช้จ่าย
              </div>
              <div
                class="flex d-flex justify-space-between"
                style="min-width: 61px; max-width: 61px"
              >
                <v-divider vertical></v-divider>
                <div style="min-width: 40px; max-width: 40px"></div>
                <v-divider vertical></v-divider>
              </div>
              <div
                v-for="(m, ym_index) in region.yearMonthList"
                :key="ym_index"
                class="flex"
                style="min-width: 43px; max-width: 43px"
              >
                <div v-if="isInCorrectRange(m)">
                  <div class="tiny-field">
                    {{ budgetPlan(region.form_c_list, ym_index) }}
                  </div>
                </div>
                <div v-else>
                  <div class="tiny-field">
                    {{ budgetPlan(region.form_c_list, ym_index) }}
                  </div>
                </div>
              </div>
              <div
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{ budgetPlanActive(region.form_c_list) }}
              </div>
              <div
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{ budgetPlanActivePercent(region.form_c_list) }}
              </div>
              <div style="min-width: 120px; max-width: 120px"></div>
              <div style="min-width: 120px; max-width: 120px"></div>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="d-flex gap-8">
              <div class="flex" style="min-width: 30px; max-width: 30px"></div>
              <div class="flex" style="min-width: 120px; max-width: 120px">
                การใช้จ่ายจริง
              </div>
              <div
                class="flex d-flex justify-space-between"
                style="min-width: 61px; max-width: 61px"
              >
                <v-divider vertical></v-divider>
                <div style="min-width: 40px; max-width: 40px"></div>
                <v-divider vertical></v-divider>
              </div>
              <div
                v-for="(m, ym_index) in region.yearMonthList"
                :key="ym_index"
                class="flex"
                style="min-width: 43px; max-width: 43px"
              >
                <div
                  class="tiny-field"
                  :class="{ 'correct-range-cell': isInCorrectRange(m) }"
                >
                  {{ budgetUse(region.form_c_list, ym_index) }}
                </div>
              </div>
              <div
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{ budgetUseActive(region.form_c_list) }}
              </div>
              <div
                class="flex tiny-field"
                style="min-width: 43px; max-width: 43px"
              >
                {{
                  formatNumber(
                    parseFloat(
                      (budgetUseActive(region.form_c_list) * 100) /
                        budgetPlanActive(region.form_c_list)
                    ),
                    2
                  )
                }}
              </div>
              <div style="min-width: 120px; max-width: 120px"></div>
              <div style="min-width: 120px; max-width: 120px"></div>
            </div>
          </div>
        </div>

        <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
      </div>
    </divcard>

    <!-- Progress Followed Modal -->
    <v-dialog v-model="modalData.show" max-width="600">
      <v-card>
        <!-- Modal Header -->
        <div class="pa-6 pb-4">
          <div class="d-flex align-center justify-space-between">
            <div>
              <div class="d-flex align-center gap-8">
                <Iconify
                  v-if="modalData.section === 'responsible'"
                  icon="mdi:account-plus"
                  color="var(--theme-color-one)"
                  style="font-size: 22px; flex-shrink: 0;"
                ></Iconify>
                <div class="font-24 font-w-700 font-ch text-theme-1">{{ getModalTitle() }}</div>
              </div>
              <div class="font-14 grey--text mt-1">{{ getModalSubtitle() }}</div>
            </div>
            <v-btn icon @click="closeModal()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <!-- Modal Content -->
        <div class="pa-6" style="background-color: #EFEFEF">
          <!-- Responsible Section -->
          <div v-if="modalData.section === 'responsible'" class="pa-4" style="background-color: white; border-radius: 16px;">
            <div class="d-flex align-center justify-space-between mb-4">
              <div class="font-16 font-w-700 font-ch text-theme-1">
                รายการผู้รับผิดชอบ
              </div>
              <v-btn
                v-if="!modalData.readonly"
                small
                rounded
                style="background-color: var(--theme-color-seven); color: white;"
                @click="addResponsibleRow()"
              >
                <v-icon size="14px" class="mr-1">mdi-plus</v-icon>
                เพิ่มผู้รับผิดชอบ
              </v-btn>
            </div>
            <v-form ref="modalForm" v-model="modalValid" lazy-validation>
              <div
                v-for="(person, idx) in modalData.responsibleList"
                :key="idx"
                class="mb-1"
              >
                <div class="d-flex align-center gap-8">
                  <div class="flex">
                    <div class="mb-1 modal-field-label">ชื่อผู้รับผิดชอบ</div>
                    <TextField
                      theme="3"
                      :value="person.taker"
                      @onChange="person.taker = $event"
                      placeholder="โปรดระบุ"
                      :rules="modalData.readonly ? [] : [(v) => !!v || 'กรุณาระบุชื่อ']"
                      :readonly="modalData.readonly"
                    ></TextField>
                  </div>
                  <div class="flex">
                    <div class="mb-1 d-flex align-center gap-4">
                      <span class="modal-field-label">ค่างาน</span>
                      <span class="grey--text">(ชั่วโมง/ปี)</span>
                    </div>
                    <TextField
                      theme="3"
                      :value="person.hours"
                      @onChange="person.hours = $event"
                      placeholder="โปรดระบุ"
                      input-type="decimal"
                      :rules="modalData.readonly ? [] : [(v) => !!v || 'กรุณาระบุค่างาน']"
                      :readonly="modalData.readonly"
                    ></TextField>
                  </div>
                  <v-btn
                    v-if="!modalData.readonly"
                    icon
                    color="#F15A29"
                    @click="removeResponsibleRow(idx)"
                  >
                    <v-icon>mdi-close-circle</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-form>
          </div>

          <!-- Explanation Section -->
          <div v-else-if="modalData.section === 'explanation'" class="pa-4" style="background-color: white; border-radius: 16px;">
            <div class="d-flex align-center justify-space-between mb-4">
              <div class="font-16 font-w-700 font-ch text-theme-1">
                คำชี้แจง
              </div>
            </div>
            <v-form ref="modalForm" v-model="modalValid" lazy-validation>
              <v-textarea
                v-model="modalInputValue"
                outlined
                dense
                rows="4"
                color="#F7941D"
                style="border-radius: 20px"
                :placeholder="modalData.type === 'add' ? 'กรุณาระบุคำชี้แจง' : 'แก้ไขคำชี้แจง'"
                :rules="modalData.readonly ? [] : [(v) => !!v || 'กรุณาระบุคำชี้แจง']"
                :readonly="modalData.readonly"
              ></v-textarea>
            </v-form>
          </div>
        </div>

        <!-- Modal Actions -->
        <div class="d-flex justify-space-between pa-6">
          <v-btn
            width="100"
            height="35"
            depressed
            rounded
            color="#D9D9D9"
            @click="closeModal()"
          >
            <span class="font-14 font-w-700 font-ch">ยกเลิก</span>
          </v-btn>
          <v-btn
            v-if="!modalData.readonly"
            width="100"
            height="35"
            dark
            rounded
            class="btn_gradient"
            @click="saveModal()"
          >
            <span class="font-14 font-w-700 font-ch">บันทึก</span>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TextField from "../../components/input/TextField";
import SelectBox from "../../components/input/SelectBox";
import { mapState } from "vuex";
import AutoBox from "@/components/input/AutoBox";
import Button from "@/components/input/Button";
import { formatNumber } from "@/plugins/global-funcs";
import { format } from "date-fns";
import { th } from "date-fns/locale";
import DatePicker from "../../components/input/DatePicker";
import { Chart } from "highcharts-vue";
import * as XLSX from "xlsx";

export default {
  name: "ProgressFollowed",
  components: {
    TextField,
    SelectBox,
    AutoBox,
    Button,
    DatePicker,
    highcharts: Chart,
  },
  data() {
    return {
      menu_extend_date: false,
      menu_expiration_date: false,
      today: null,
      form: {
        form_c_id: "",
        extend_year: "",
        extend_month: "",
        extend_date: "",
        expiration_date: "",
        form_type: "",
      },
      // Progress Followed Modal Data
      modalData: {
        show: false,
        section: "", // 'responsible' | 'explanation'
        role: "RSP", // 'RSP' | 'สป.อว.'
        readonly: false,
        item: null,
        type: "", // 'add' | 'edit' (explanation only)
        value: "",
        responsibleList: [], // [{ name: '', hours: '' }]
      },
      // Modal form data
      modalValid: true,
      modalInputValue: "",
      // Team management
      teams: [],
      emailRules: [
        (v) => !!v || "กรุณาระบุอีเมล",
        (v) => /.+@.+\..+/.test(v) || "รูปแบบอีเมลไม่ถูกต้อง",
      ],
      formatNumber,
      masterData: {},
      regions: [],
      yearBudgetList: [],
      yearList: [],
      monthList: [
        {
          value: "1",
          name: "มกราคม",
        },
        {
          value: "2",
          name: "กุมภาพันธ์",
        },
        {
          value: "3",
          name: "มีนาคม",
        },
        {
          value: "4",
          name: "เมษายน",
        },
        {
          value: "5",
          name: "พฤษภาคม",
        },
        {
          value: "6",
          name: "มิถุนายน",
        },
        {
          value: "7",
          name: "กรกฎาคม",
        },
        {
          value: "8",
          name: "สิงหาคม",
        },
        {
          value: "9",
          name: "กันยายน",
        },
        {
          value: "10",
          name: "ตุลาคม",
        },
        {
          value: "11",
          name: "พฤศจิกายน",
        },
        {
          value: "12",
          name: "ธันวาคม",
        },
      ],
      formC: [],
      formD: [],
      formF: [],
      chartData: [
        {
          region: "",
          chartOptions: {},
        },
      ],
      isScurve: false,
      selectedFilter: "all",
      activeSeriesNames: ["แผนการดำเนินงาน", "ผลการดำเนินงาน", "แผนการใช้จ่ายเงิน", "การใช้จ่ายจริง"],
      regionExpanded: [],
      masterSeries: [
        { name: "แผนการดำเนินงาน", data: [], color: "rgba(255, 209, 102, 1)" },
        { name: "ผลการดำเนินงาน", data: [], color: "rgba(255, 166, 41, 1)" },
        { name: "แผนการใช้จ่ายเงิน", data: [], color: "rgba(140, 74, 47, 1)" },
        { name: "การใช้จ่ายจริง", data: [], color: "rgba(241, 90, 41, 1)" },
      ],
      displaySeries: [],
      filterOptions: [
        { value: "all", name: "ทั้งหมด" },
        { value: "แผนการดำเนินงาน", name: "แผนการดำเนินงาน" },
        { value: "ผลการดำเนินงาน", name: "ผลการดำเนินงาน" },
        { value: "แผนการใช้จ่ายเงิน", name: "แผนการใช้จ่ายเงิน" },
        { value: "การใช้จ่ายจริง", name: "การใช้จ่ายจริง" },
      ],
      chartOptions: {
        chart: {
          type: "areaspline",
          backgroundColor: "#fff",
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: [],
          gridLineWidth: 1,
          lineWidth: 1,
          startOnTick: true,
          endOnTick: true,
          tickmarkPlacement: "on",
        },
        yAxis: {
          title: { text: "เปอร์เซ็นต์ (%)" },
          max: 100,
          gridLineWidth: 0,
          lineWidth: 1,
        },
        legend: { enabled: false },
        tooltip: {
          shared: true,
          backgroundColor: "#333333",
          borderColor: "#333333",
          style: {
            color: "#ffffff",
          },
        },
        plotOptions: {
          series: {
            pointPlacement: "on",
            fillOpacity: 0.3,
            marker: {
              enabled: true,
            },
          },
        },
        series: [],
      },
    };
  },
  created() {
    this.today = new Date().toISOString().split("T")[0];
    this.generateYearList();
    this.getProgress();
  },
  computed: {
    ...mapState({
      isUSP: (state) => state.Auth.User.user_type === "USP",
      isRSP: (state) => state.Auth.User.user_type === "RSP",
      isOIC: (state) => state.Auth.User.user_type === "สป.อว.",
      userInfo: (state) => state.Auth.User,
    }),

    projectStartDate() {
      return this.extend_date ? this.extend_date.split(" ")[0] : this.today;
    },
    projectEndDate() {
      return this.expiration_date
        ? this.expiration_date.split(" ")[0]
        : undefined;
    },
    seriesNames() {
      return this.filterOptions.map((option) => ({
        value: option.value,
        text: option.name,
      }));
    },
    legendSeries() {
      return this.masterSeries;
    },
    selectedPlanLabel() {
      const masterData = this.masterData || {};
      const plans = Array.isArray(masterData.plan_masters)
        ? masterData.plan_masters
        : [];
      const planId = masterData.plan_master_id;
      if (!plans.length || !planId) {
        return "-";
      }
      const numericId = Number(planId);
      const plan =
        plans.find((item) => Number(item.id) === numericId) ||
        plans.find((item) => item.id === planId);
      if (!plan) {
        return "-";
      }
      return plan.plan_name_en
        ? `${plan.plan_name_th} (${plan.plan_name_en})`
        : plan.plan_name_th || "-";
    },
    selectedMainProjectName() {
      const masterData = this.masterData || {};
      const projects = Array.isArray(masterData.main_project_list)
        ? masterData.main_project_list
        : [];
      const projectId = masterData.main_project_id;
      if (!projectId) {
        return projects.length ? "ทั้งหมด" : "-";
      }
      const numericId = Number(projectId);
      const project =
        projects.find((item) => Number(item.id) === numericId) ||
        projects.find((item) => item.id === projectId);
      return project?.name || "-";
    },
    selectedRegionName() {
      const masterData = this.masterData || {};
      const regions = Array.isArray(masterData.region_masters)
        ? masterData.region_masters
        : [];
      const regionId = masterData.region_id;
      if (!regionId) {
        return regions.length ? "ทั้งหมด" : "-";
      }
      const numericId = Number(regionId);
      const region =
        regions.find((item) => Number(item.id) === numericId) ||
        regions.find((item) => item.id === regionId);
      return region?.name || "-";
    },
  },
  methods: {
    exportProgressExcel() {
      if (!this.regions || !this.regions.length) {
        this.$store.commit("General/setModal", {
          title: "แจ้งเตือน",
          theme: "warning",
          text: "ไม่พบข้อมูลสำหรับส่งออก",
          showCancel: false,
        });
        return;
      }

      if (!this.chartData || !this.chartData.length) {
        this.generateChartData();
      }

      const workbook = XLSX.utils.book_new();

      // Calculate comprehensive summary statistics
      const totalProjects = this.regions.reduce((sum, region) => {
        return sum + (region?.form_c_list?.length || 0);
      }, 0);

      // Calculate overall progress statistics
      let totalPlanSum = 0;
      let totalResultSum = 0;
      let totalWFSum = 0;
      let totalHoursSum = 0;
      let totalHours2Sum = 0;
      let projectsWithProgress = 0;
      let projectsCompleted = 0;
      let projectsWithDelay = 0;

      const regionStats = this.regions.map(region => {
        const projects = region?.form_c_list || [];
        let regionPlan = 0;
        let regionResult = 0;
        let regionWF = 0;
        let regionHours = 0;
        let regionHours2 = 0;
        let regionCompleted = 0;
        let regionWithProgress = 0;
        let regionWithDelay = 0;

        projects.forEach(item => {
          const plan = parseFloat(item?.plan) || 0;
          const result = parseFloat(item?.result) || 0;
          const wf = parseFloat(item?.wf) || 0;
          const hours = parseFloat(item?.progress_month_taker_hours) || 0;
          const hours2 = parseFloat(item?.progress_month_taker_hours_2) || 0;

          regionPlan += plan;
          regionResult += result;
          regionWF += wf;
          regionHours += hours;
          regionHours2 += hours2;

          // Check completion status
          const actualPercent = plan > 0 ? (result / plan * 100) : 0;
          if (actualPercent >= 100) regionCompleted++;
          if (result > 0) regionWithProgress++;
          if (result < plan && plan > 0) regionWithDelay++;
        });

        totalPlanSum += regionPlan;
        totalResultSum += regionResult;
        totalWFSum += regionWF;
        totalHoursSum += regionHours;
        totalHours2Sum += regionHours2;
        projectsCompleted += regionCompleted;
        projectsWithProgress += regionWithProgress;
        projectsWithDelay += regionWithDelay;

        return {
          name: region?.name || 'ไม่ระบุ',
          projectCount: projects.length,
          percentage: totalProjects > 0 ? ((projects.length / totalProjects) * 100).toFixed(2) : '0.00',
          planSum: regionPlan.toFixed(2),
          resultSum: regionResult.toFixed(2),
          avgProgress: projects.length > 0 ? (regionResult / Math.max(regionPlan, 1) * 100).toFixed(2) : '0.00',
          wfSum: regionWF.toFixed(2),
          hoursSum: (regionHours + regionHours2).toFixed(2),
          completedCount: regionCompleted,
          progressCount: regionWithProgress
        };
      });

      // Calculate time period info
      const allYearMonths = this.regions.reduce((acc, region) => {
        if (region?.yearMonthList) {
          region.yearMonthList.forEach(ym => {
            const key = `${ym.year_th}-${ym.month_th}`;
            if (!acc.includes(key)) acc.push(key);
          });
        }
        return acc;
      }, []);

      // Build comprehensive summary sheet data with better column layout
      const summaryData = [
        ["รายงานสรุปการติดตามความก้าวหน้า", "", "", "", "", "", ""],
        [""], // Empty row
        ["ข้อมูลทั่วไป", "", "", "สถิติโครงการ", ""],
        ["แผนงาน", this.selectedPlanLabel || "-", "", "จำนวนโครงการทั้งหมด", totalProjects],
        ["โครงการหลัก", this.selectedMainProjectName || "-", "โครงการที่มีความก้าวหน้า", "", `${projectsWithProgress} (${totalProjects > 0 ? (projectsWithProgress / totalProjects * 100).toFixed(1) : '0'}%)`],
        ["ปี งปม.", this.masterData?.fiscal_year || "-", "", "โครงการที่เสร็จสมบูรณ์", `${projectsCompleted} (${totalProjects > 0 ? (projectsCompleted / totalProjects * 100).toFixed(1) : '0'}%)`],
        ["ภูมิภาค", this.selectedRegionName || "-", "", "โครงการที่ล่าช้า", `${projectsWithDelay} (${totalProjects > 0 ? (projectsWithDelay / totalProjects * 100).toFixed(1) : '0'}%)`],
        ["วันที่ส่งออกข้อมูล", new Date().toLocaleDateString('th-TH'), "", ""],
        [""], // Empty row

        ["สถิติงบประมาณและผลการดำเนินงาน", "", "สถิติชั่วโมงการทำงาน", ""],
        ["แผนงบประมาณรวม", `${totalPlanSum.toLocaleString()} %`, "ชั่วโมงทำงานรวมทั้งหมด", `${totalHoursSum.toLocaleString()} ชั่วโมง`],
        ["ผลการใช้งบประมาณรวม", `${totalResultSum.toLocaleString()} %`, "ชั่วโมงทำงานเพิ่มเติม", `${totalHours2Sum.toLocaleString()} ชั่วโมง`],
        ["เปอร์เซ็นต์การใช้งบประมาณ", `${totalPlanSum > 0 ? (totalResultSum / totalPlanSum * 100).toFixed(2) : '0.00'}%`, "รวมชั่วโมงทั้งหมด", `${(totalHoursSum + totalHours2Sum).toLocaleString()} ชั่วโมง`],
        ["งบประมาณคงเหลือ", `${(totalPlanSum - totalResultSum).toLocaleString()} %`, "", ""],
        [""], // Empty row

        ["ข้อมูลช่วงเวลา", "", "", ""],
        ["จำนวนเดือนที่รายงาน", allYearMonths.length, "", ""],
        ["ช่วงเวลารายงาน", allYearMonths.length > 0 ? `${allYearMonths[0]} ถึง ${allYearMonths[allYearMonths.length - 1]}` : "-", "", ""],
        [""], // Empty row

        ["รายละเอียดตามภูมิภาค"],
        ["ภูมิภาค", "จำนวนโครงการ", "แผน (%)", "ผล (%)", "% ความก้าวหน้า", "ชั่วโมงรวม", "โครงการเสร็จ"]
      ];

      // Add detailed regional breakdown
      regionStats.forEach(stat => {
        summaryData.push([
          stat.name,
          `${stat.projectCount} (${stat.percentage}%)`,
          stat.planSum,
          stat.resultSum,
          `${stat.avgProgress}%`,
          stat.hoursSum,
          `${stat.completedCount}/${stat.projectCount}`
        ]);
      });

      const summarySheet = XLSX.utils.aoa_to_sheet(summaryData);

      // Set column widths for better readability
      const columnWidths = [
        { wch: 25 }, // A: Labels
        { wch: 20 }, // B: Values
        { wch: 25 }, // C: Labels
        { wch: 20 }, // D: Values
        { wch: 15 }, // E: Labels/Values
        { wch: 15 }, // F: Values
        { wch: 15 }  // G: Values
      ];
      summarySheet['!cols'] = columnWidths;

      XLSX.utils.book_append_sheet(workbook, summarySheet, "Summary");

      const usedSheetNames = new Set(["Summary"]);

      this.regions.forEach((region, index) => {
        const headerRow = this.buildRegionHeader(region);
        const regionRows = this.buildRegionRows(region, headerRow.length);
        const worksheet = XLSX.utils.aoa_to_sheet([headerRow, ...regionRows]);
        const sheetName = this.generateSheetName(
          region?.name ? `Data - ${region.name}` : "",
          index,
          usedSheetNames,
          "Data"
        );
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

        const chartSheetData = this.buildChartSheet(region);
        if (chartSheetData.length > 1) {
          const chartSheet = XLSX.utils.aoa_to_sheet(chartSheetData);
          const chartSheetName = this.generateSheetName(
            region?.name ? `Chart - ${region.name}` : "",
            index + this.regions.length,
            usedSheetNames,
            "Chart"
          );
          XLSX.utils.book_append_sheet(workbook, chartSheet, chartSheetName);
        }
      });

      const fiscalYear = this.masterData?.fiscal_year || "export";
      const fileName = `progress-followed-${fiscalYear}-${format(
        new Date(),
        "yyyyMMdd"
      )}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    },
    buildRegionHeader(region) {
      const header = ["โครงการ", "WF"];
      (region?.yearMonthList || []).forEach((ym) => {
        header.push(`${ym.month_th} ${ym.year_th}`);
      });
      header.push("แผนผล");
      header.push("%");
      header.push("ผู้รับผิดชอบ");
      header.push("ค่างาน");
      header.push("คำชี้แจง");
      return header;
    },
    buildRegionRows(region, columnCount) {
      const rows = [];
      const monthCount = region?.yearMonthList?.length || 0;
      (region?.form_c_list || []).forEach((item) => {
        // Row 1: แผน
        const planRow = [
          this.getProjectName(item),
          this.formatExcelNumber(item?.wf),
        ];
        for (let idx = 0; idx < monthCount; idx++) {
          const budget = item?.project_section_plan_p1_budget?.[idx] || {};
          planRow.push(this.formatExcelNumber(budget?.month_value));
        }
        planRow.push(this.formatExcelNumber(item?.plan));
        planRow.push(this.formatExcelNumber(item?.percent));
        planRow.push(item?.progress_month_taker || "");
        planRow.push(this.formatExcelNumber(item?.progress_month_taker_hours));
        planRow.push(item?.progress_month_remark || "");
        rows.push(planRow);

        // Row 2: ผล
        const resultRow = ["", ""];
        for (let idx = 0; idx < monthCount; idx++) {
          const budget = item?.project_section_plan_p1_budget?.[idx] || {};
          resultRow.push(this.formatExcelNumber(budget?.actual_month_value));
        }
        resultRow.push(this.formatExcelNumber(item?.result));
        resultRow.push(this.calculateActualPercent(item));
        resultRow.push(item?.progress_month_taker_2 || "");
        resultRow.push(this.formatExcelNumber(item?.progress_month_taker_hours_2));
        resultRow.push(item?.progress_month_remark_2 || "");
        rows.push(resultRow);
      });

      if (!rows.length) {
        const placeholder = Array(columnCount).fill("");
        placeholder[0] = "ไม่มีข้อมูล";
        rows.push(placeholder);
      }

      const summaryRows = this.buildSummaryRows(region, columnCount);
      return summaryRows.length
        ? [...rows, Array(columnCount).fill(""), ...summaryRows]
        : rows;
    },
    buildSummaryRows(region, columnCount) {
      const plans = region?.form_c_list || [];
      if (!plans.length) {
        return [];
      }
      const monthCount = region?.yearMonthList?.length || 0;
      const rows = [];
      const activePlan = this.weightActivePlan(plans);
      const activeResult = this.weightActiveResult(plans);
      const budgetPlanActive = this.budgetPlanActive(plans);
      const budgetUseActive = this.budgetUseActive(plans);

      rows.push(
        this.createSummaryRow({
          labelPrefix: "แผนงานถ่วงน้ำหนัก",
          columnCount,
          monthCount,
          wfValue: this.totalWF(plans),
          monthPlanGetter: (index) => this.weightPlan(plans, index),
          planValue: activePlan,
          percentPlanValue: this.weightActivePlanPercent(plans),
        })
      );
      rows.push(
        this.createSummaryRow({
          labelPrefix: "ผลการดำเนินงาน",
          columnCount,
          monthCount,
          monthActualGetter: (index) => this.resultPlan(plans, index),
          resultValue: activeResult,
          percentResultValue: this.safePercent(activeResult, activePlan),
        })
      );
      rows.push(
        this.createSummaryRow({
          labelPrefix: "แผนการใช้จ่าย",
          columnCount,
          monthCount,
          monthPlanGetter: (index) => this.budgetPlan(plans, index),
          planValue: budgetPlanActive,
          percentPlanValue: this.budgetPlanActivePercent(plans),
        })
      );
      rows.push(
        this.createSummaryRow({
          labelPrefix: "การใช้จ่ายจริง",
          columnCount,
          monthCount,
          monthActualGetter: (index) => this.budgetUse(plans, index),
          resultValue: budgetUseActive,
          percentResultValue: this.safePercent(
            budgetUseActive,
            budgetPlanActive
          ),
        })
      );
      return rows;
    },
    createSummaryRow({
      labelPrefix,
      columnCount,
      monthCount,
      wfValue,
      monthPlanGetter,
      monthActualGetter,
      planValue,
      resultValue,
      percentPlanValue,
      percentResultValue,
    }) {
      const row = Array(columnCount).fill("");
      const {
        monthStartIndex,
        planColIndex,
        resultColIndex,
        percentPlanColIndex,
        percentResultColIndex,
      } = this.getExportColumnIndexes(columnCount, monthCount);
      row[0] = `${labelPrefix} (รวม)`;
      if (wfValue !== undefined && wfValue !== null && wfValue !== "") {
        row[1] = this.formatExcelNumber(wfValue);
      }
      for (let idx = 0; idx < monthCount; idx++) {
        const planVal = monthPlanGetter ? monthPlanGetter(idx) : "";
        const actualVal = monthActualGetter ? monthActualGetter(idx) : "";
        const val = planVal !== "" ? planVal : actualVal;
        row[monthStartIndex + idx] = this.formatExcelNumber(val);
      }
      if (planValue !== undefined && planValue !== null && planValue !== "") {
        row[planColIndex] = this.formatExcelNumber(planValue);
      }
      if (
        resultValue !== undefined &&
        resultValue !== null &&
        resultValue !== ""
      ) {
        row[resultColIndex] = this.formatExcelNumber(resultValue);
      }
      if (
        percentPlanValue !== undefined &&
        percentPlanValue !== null &&
        percentPlanValue !== ""
      ) {
        row[percentPlanColIndex] = this.formatExcelNumber(percentPlanValue);
      }
      if (
        percentResultValue !== undefined &&
        percentResultValue !== null &&
        percentResultValue !== ""
      ) {
        row[percentResultColIndex] = this.formatExcelNumber(percentResultValue);
      }
      return row;
    },
    getExportColumnIndexes(columnCount, monthCount) {
      const monthStartIndex = 2;
      const trailingColumns = 5;
      if (!monthCount || monthCount < 0) {
        monthCount = columnCount - monthStartIndex - trailingColumns;
      }
      const planColIndex = monthStartIndex + monthCount;
      return {
        monthStartIndex,
        planColIndex,
        resultColIndex: planColIndex,
        percentPlanColIndex: planColIndex + 1,
        percentResultColIndex: planColIndex + 1,
      };
    },
    buildChartSheet(region) {
      const chartRegion = this.getChartRegionData(region?.name);
      if (!chartRegion) {
        return [];
      }
      const seriesList = chartRegion.allSeries || [];
      if (!seriesList.length) {
        return [];
      }
      const header = ["เดือน", ...seriesList.map((series) => series.name)];
      const rows = (chartRegion.categories || []).map((category, index) => {
        const row = [category];
        seriesList.forEach((series) => {
          const value = Array.isArray(series.data) ? series.data[index] : "";
          row.push(
            value === null || value === undefined
              ? ""
              : this.formatExcelNumber(value)
          );
        });
        return row;
      });
      return [header, ...rows];
    },
    getChartRegionData(regionName) {
      if (!regionName || !this.chartData || !this.chartData.length) {
        return null;
      }
      return this.chartData.find((data) => data.region === regionName) || null;
    },
    getProjectName(item) {
      return (
        item?.project_section_general_info?.project_name_th ||
        item?.project_section_general_info?.lab_name ||
        item?.form_a?.main_project?.name ||
        "-"
      );
    },
    formatExcelNumber(value, decimals = 2) {
      if (
        value === null ||
        value === undefined ||
        value === "" ||
        value === "-"
      ) {
        return "";
      }
      const numeric = Number(value);
      if (isNaN(numeric)) {
        return value;
      }
      return Number(numeric.toFixed(decimals));
    },
    formatMonthCell(planValue, actualValue) {
      const plan = this.formatExcelNumber(planValue);
      const actual = this.formatExcelNumber(actualValue);
      const parts = [];
      if (plan !== "") {
        parts.push(`${plan}`);
      }
      if (actual !== "") {
        parts.push(`${actual}`);
      }
      return parts.join("\n");
    },
    calculateActualPercent(item) {
      return this.formatExcelNumber(this.safePercent(item?.result, item?.plan));
    },
    generateSheetName(name, index, usedNames, fallbackPrefix = "Region") {
      const fallback = `${fallbackPrefix} ${index + 1}`;
      let baseName = (name || fallback)
        .toString()
        .replace(/[\\/?*\[\]:]/g, " ")
        .trim();
      if (!baseName) {
        baseName = fallback;
      }
      baseName = baseName.substring(0, 31);
      let candidate = baseName;
      let counter = 1;
      while (usedNames.has(candidate)) {
        const suffix = ` (${counter})`;
        const prefix = baseName.substring(0, 31 - suffix.length);
        candidate = `${prefix}${suffix}`;
        counter++;
      }
      usedNames.add(candidate);
      return candidate;
    },
    safePercent(numerator, denominator) {
      const num = Number(numerator);
      const den = Number(denominator);
      if ((num || num === 0) && den && !isNaN(num) && !isNaN(den)) {
        return (num * 100) / den;
      }
      return "";
    },
    async getProgress() {
      let payload = {
        main_project_id: this.masterData.main_project_id,
        plan_master_id: this.masterData.plan_master_id,
        region_id: this.masterData.region_id,
        fiscal_year: this.masterData.fiscal_year,
      };
      let res;
      res = await this.$apiFire("MonthlyProgress/getProgressRSP", payload);
      for (const x of res?.regions) {
        for (const c of x.form_c_list) {
          c.percent = this.getLastProgress(c.project_section_plan_p1_budget);
          let i = 0;
          for (const y of c.project_section_plan_p1_budget) {
            let correctIndex = this.isInCorrectRange(y, i);
            if (typeof correctIndex !== "boolean") {
              c.plan = y.month_value;
              c.result = y.actual_month_value;
            }
            i++;
          }
        }
        x.yearMonthList = x.yearMonthList.map((ym) => ({
          yearMonth: ym, // Keep original date string for isInCorrectRange
          month_th: format(new Date(ym), "MMM", { locale: th }), // to TH short month
          year_th: (parseInt(ym.toString().split("-")[0]) + 543)
            .toString()
            .slice(2), // last 2 letters of year string
        }));
      }
      this.masterData = { ...res, regions: undefined };
      this.regions = res.regions;
      this.regionExpanded = this.regions.map(() => true);
      this.formC = res.form_c.map((item) => ({
        id: item.id,
        name: item.project_section_general_info.project_name_th,
      }));
      this.formD = res.form_d?.map((item) => ({
        id: item.id,
        name: item.form_a.main_project.name,
      }));
      this.formF = res.form_f?.map((item) => ({
        id: item.id,
        name: item.form_a.main_project.name,
      }));

      this.initializeChart();
    },

    async onSubmit() {
      if (this.$refs.form.validate()) {
        //
        let payload = {
          form_c_id:
            this.form.form_type === "c" ? this.form.form_c_id : undefined,
          form_b_id:
            this.form.form_type === "d" || this.form.form_type === "f"
              ? this.form.form_c_id
              : undefined,
          extend_year: this.form.extend_year,
          extend_month: this.form.extend_month,
          extend_date: this.form.extend_date,
          expiration_date: this.form.expiration_date,
        };

        let res = await this.$apiFire(
          "MonthlyProgress/extendProgressMonth",
          payload
        );
        if (res) {
          this.$store.commit("General/setModal", {
            title: "เสร็จสิ้น!",
            theme: "success",
            text: "บันทึกข้อมูลสำเร็จ",
            showCancel: false,
            // action: () => this.$router.push({ name: "UserManagement" }),
          });
        }
      }
    },

    resetForm() {
      this.$refs.form.reset();
    },

    totalWF(plans) {
      if (!plans || plans.length === 0) return "-";
      let total = plans
        .map((x) => x.wf)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    operationPlan(plans, index) {
      let total = [];
      for (const x of plans) {
        let result = x.project_section_plan_p1_budget[index]
          ? parseFloat(x.project_section_plan_p1_budget[index].month_value)
          : 0;
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0) / plans.length;
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    weightPlan(plans, index) {
      let total = [];
      for (const x of plans) {
        let result = x.project_section_plan_p1_budget[index]
          ? parseFloat(
              x.project_section_plan_p1_budget[index].month_value * x.wf
            )
          : 0;
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    weightActivePlan(plans) {
      let ind = 0;
      for (const x of plans) {
        let i = 0;
        for (const y of x.project_section_plan_p1_budget) {
          let correctIndex = this.isInCorrectRange(y, i);
          if (typeof correctIndex !== "boolean")
            return this.weightPlan(plans, correctIndex);
          i++;
        }
        ind++;
      }
    },
    weightActivePlanPercent(plans) {
      let all = [];
      for (let i = 0; i < plans.length; i++) {
        all.push(this.weightPlan(plans, i));
      }

      if (all.length > 0) {
        for (const x of all.reverse()) {
          if (!!x && x !== "-") {
            return x;
          }
        }
      }
      return "-";
    },
    weightActiveResult(plans) {
      let ind = 0;
      for (const x of plans) {
        let i = 0;
        for (const y of x.project_section_plan_p1_budget) {
          let correctIndex = this.isInCorrectRange(y, i);
          if (typeof correctIndex !== "boolean")
            return this.resultPlan(plans, correctIndex);
          i++;
        }
        ind++;
      }
    },
    resultPlan(plans, index) {
      let total = [];
      for (const x of plans) {
        let result = !x.project_section_plan_p1_budget[index]
          ?.actual_month_value
          ? 0
          : parseFloat(
              x.project_section_plan_p1_budget[index]?.actual_month_value * x.wf
            );
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    budgetPlan(plans, index) {
      let total = [];
      for (const x of plans) {
        let result = !x.project_section_plan_p1_budget[index]?.plan_budget_rate
          ? 0
          : parseFloat(
              x.project_section_plan_p1_budget[index].plan_budget_rate * x.wf
            );
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    budgetUse(plans, index) {
      let total = [];
      for (const x of plans) {
        let result = !x.project_section_plan_p1_budget[index]?.use_budget_rate
          ? 0
          : parseFloat(
              x.project_section_plan_p1_budget[index].use_budget_rate * x.wf
            );
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    budgetPlanActive(plans) {
      let ind = 0;
      for (const x of plans) {
        let i = 0;
        for (const y of x.project_section_plan_p1_budget) {
          let correctIndex = this.isInCorrectRange(y, i);
          if (typeof correctIndex !== "boolean")
            return this.budgetPlan(plans, correctIndex);
          i++;
        }
        ind++;
      }
    },
    budgetUseActive(plans) {
      let ind = 0;
      for (const x of plans) {
        let i = 0;
        for (const y of x.project_section_plan_p1_budget) {
          let correctIndex = this.isInCorrectRange(y, i);
          if (typeof correctIndex !== "boolean")
            return this.budgetUse(plans, correctIndex);
          i++;
        }
        ind++;
      }
    },
    budgetPlanActivePercent(plans) {
      let all = [];
      for (let i = 0; i < plans.length; i++) {
        all.push(this.budgetPlan(plans, i));
      }

      if (all.length > 0) {
        for (const x of all.reverse()) {
          if (!!x && x !== "-") {
            return x;
          }
        }
      }
      return "-";
    },
    getLastProgress(items) {
      items = this.removeVModel(items);
      if (items && typeof items === "object" && items.length > 0) {
        for (const x of items.reverse()) {
          if (!!x.month_value && x.month_value !== "-") {
            return x.month_value;
          }
        }
      }
      return "-";
    },
    removeVModel(item) {
      return JSON.parse(JSON.stringify(item));
    },
    isInCorrectRange(item, index = null) {
      let today = new Date();
      let currentMonth = today.getMonth();

      // Handle different data structures
      let dateToCheck;
      if (item.year_month) {
        dateToCheck = new Date(item.year_month);
      } else if (item.yearMonth) {
        dateToCheck = new Date(item.yearMonth);
      } else if (typeof item === "string") {
        // If item is a raw year-month string like from original data
        dateToCheck = new Date(item);
      } else {
        // For yearMonthList items that have been transformed but no yearMonth field
        return false;
      }

      let thisMonth = dateToCheck.getMonth();
      let thisYear = dateToCheck.getFullYear();
      let currentYear = today.getFullYear();

      let isCorrectCase =
        ((today.getDate() >= 5 && thisMonth === currentMonth) ||
          (today.getDate() <= 4 && thisMonth === currentMonth - 1)) &&
        thisYear === currentYear;

      // for return active yearMonth index
      if (isCorrectCase && index !== null) return index;
      return isCorrectCase;
    },
    generateYearList() {
      var currentYear = new Date().getFullYear();
      var currentMonth = new Date().getMonth() + 1;
      var yearList = [];

      if (currentMonth >= 10) currentYear++;

      for (var year = currentYear; year >= currentYear - 20; year--) {
        yearList.push(year + 543);
      }

      this.yearList = yearList;
    },

    ToScurve() {
      this.isScurve = !this.isScurve;
    },

    initializeChart() {
      this.generateChartData();
      this.applyFilter();
    },

    generateChartData() {
      this.chartData = this.regions.map((region) => {
        const seriesData = this.masterSeries.map((series) => {
          return {
            name: series.name,
            color: series.color,
            data: region.yearMonthList.map((ym, index) => {
              let value;
              switch (series.name) {
                case "แผนการดำเนินงาน":
                  value = this.operationPlan(region.form_c_list, index);
                  break;
                case "ผลการดำเนินงาน":
                  value = this.resultPlan(region.form_c_list, index);
                  break;
                case "แผนการใช้จ่ายเงิน":
                  value = this.budgetPlan(region.form_c_list, index);
                  break;
                case "การใช้จ่ายจริง":
                  value = this.budgetUseActive(region.form_c_list);
                  break;
                default:
                  value = 0;
              }
              return value !== "-" ? parseFloat(value) : null;
            }),
          };
        });

        return {
          region: region.name,
          categories: region.yearMonthList.map(
            (ym) => `${ym.month_th} ${ym.year_th}`
          ),
          allSeries: seriesData,
          filteredSeries: [...seriesData],
        };
      });
    },

    toggleSeries(name) {
      if (this.activeSeriesNames.length === this.masterSeries.length) {
        this.activeSeriesNames = [name];
      } else {
        const idx = this.activeSeriesNames.indexOf(name);
        if (idx === -1) {
          this.activeSeriesNames.push(name);
        } else if (this.activeSeriesNames.length === 1) {
          this.activeSeriesNames = this.masterSeries.map((s) => s.name);
        } else {
          this.activeSeriesNames.splice(idx, 1);
        }
      }
      this.selectedFilter = "all";
      this.applyFilter();
    },

    applyFilter() {
      this.chartData.forEach((regionData) => {
        regionData.filteredSeries = regionData.allSeries.filter((series) =>
          this.activeSeriesNames.includes(series.name)
        );
      });
      this.displaySeries = this.masterSeries.filter((series) =>
        this.activeSeriesNames.includes(series.name)
      );
    },

    chartOptionByRegion(regionName) {
      const regionData = this.chartData.find(
        (data) => data.region === regionName
      );

      if (!regionData) {
        return this.chartOptions;
      }

      return {
        ...this.chartOptions,
        xAxis: {
          ...this.chartOptions.xAxis,
          categories: regionData.categories,
        },
        tooltip: {
          ...this.chartOptions.tooltip,
          useHTML: true,
          formatter: function () {
            const yearShort = this.x.split(" ").pop();
            const yearFull = `25${yearShort}`;
            let s = `<span style="font-size:12px;"><b>ติดตามความก้าวหน้า<br/>ภูมิภาค: ${regionName} ปี พ.ศ. ${yearFull}</b></span><br/>`;
            this.points.forEach((point) => {
              s += `<span style="font-size:10px;"><span style="display:inline-block;width:11px;height:11px;border-radius:50%;background-color:${point.series.color};margin-right:4px;vertical-align:middle;"></span>${point.series.name} : <b>${point.y}%</b></span><br/>`;
            });
            return s;
          },
        },
        series: regionData.filteredSeries,
      };
    },

    // Progress Followed Helper Methods
    getResponsibleStatus(item) {
      const rspTakers = (item.progress_month_takers || []).filter(p => p.role === 'RSP' || !p.role);
      return rspTakers.length === 0;
    },
    getResponsibleStatusSP(item) {
      const spTakers = (item.progress_month_takers || []).filter(p => p.role === 'สป.อว.');
      return spTakers.length === 0;
    },
    getSpTakers(item) {
      return (item.progress_month_takers || []).filter(p => p.role === 'สป.อว.');
    },
    getRspTakers(item) {
      return (item.progress_month_takers || []).filter(p => p.role === 'RSP' || !p.role);
    },
    getExplanationStatusSP(item) {
      return !item.progress_month_remark_sp;
    },

    formatHours(hours) {
      if (!hours) return "";
      const num = parseFloat(hours);
      return isNaN(num) ? hours : num % 1 === 0 ? String(Math.floor(num)) : String(num);
    },

    getExplanationStatus(item) {
      return !item.progress_month_remark;
    },

    getExplanationValue(item) {
      return item.progress_month_remark || "รายละเอียด";
    },

    openResponsibleModal(item, role = 'RSP') {
      const isReadonly = this.userInfo.user_type === 'สป.อว.' && role === 'RSP';
      const list = (item.progress_month_takers || []).filter(p =>
        role === 'RSP' ? (p.role === 'RSP' || !p.role) : p.role === role
      );
      this.modalData = {
        show: true,
        section: "responsible",
        role: role,
        readonly: isReadonly,
        item: item,
        type: "",
        value: "",
        responsibleList:
          list.length > 0
            ? list.map((p) => ({ taker: p.taker || "", hours: p.hours || "" }))
            : [{ taker: "", hours: "" }],
      };
    },

    openExplanationModal(item, role = 'RSP') {
      const isReadonly = this.userInfo.user_type === 'สป.อว.' && role === 'RSP';
      const field = role === 'สป.อว.' ? 'progress_month_remark_sp' : 'progress_month_remark';
      const isEmpty = !item[field];
      this.modalData = {
        show: true,
        section: "explanation",
        role: role,
        readonly: isReadonly,
        item: item,
        type: isEmpty ? "add" : "edit",
        value: item[field] || "",
        responsibleList: [],
      };
      this.modalInputValue = item[field] || "";
    },

    saveModal() {
      if (this.$refs.modalForm.validate()) {
        this.saveModalData();
      }
    },

    async saveModalData() {
      const { section, role, item, responsibleList } = this.modalData;
      const isSP = role === 'สป.อว.';

      let payload = {
        id: item.id,
        type: item.type || "C",
      };

      if (section === "responsible") {
        payload.progress_month_takers = responsibleList.map((p) => ({
          taker: p.taker,
          hours: p.hours ? parseFloat(p.hours).toFixed(2) : null,
        }));
      } else if (section === "explanation") {
        const field = isSP ? 'progress_month_remark_sp' : 'progress_month_remark';
        payload[field] = this.modalInputValue;
      }

      try {
        let res = await this.$apiFire(
          "MonthlyProgress/updateProgressData",
          payload
        );

        if (res) {
          if (section === "responsible") {
            const otherTakers = (item.progress_month_takers || []).filter(p =>
              isSP ? (p.role === 'RSP' || !p.role) : p.role === 'สป.อว.'
            );
            const newTakers = responsibleList.map(p => ({ ...p, role }));
            this.$set(item, "progress_month_takers", [...otherTakers, ...newTakers]);
          } else if (section === "explanation") {
            const field = isSP ? 'progress_month_remark_sp' : 'progress_month_remark';
            this.$set(item, field, this.modalInputValue);
          }

          this.closeModal();

          this.$store.commit("General/setModal", {
            title: "เสร็จสิ้น!",
            theme: "success",
            text: "บันทึกข้อมูลสำเร็จ",
            showCancel: false,
          });
        }
      } catch (error) {
        console.error("Error saving progress data:", error);
        this.$store.commit("General/setModal", {
          title: "เกิดข้อผิดพลาด!",
          theme: "error",
          text: "ไม่สามารถบันทึกข้อมูลได้",
          showCancel: false,
        });
      }
    },

    closeModal() {
      this.modalData = {
        show: false,
        section: "",
        role: "RSP",
        readonly: false,
        item: null,
        type: "",
        value: "",
        responsibleList: [],
      };
      this.modalInputValue = "";
      this.modalValid = true;
      this.$nextTick(() => {
        if (this.$refs.modalForm) {
          this.$refs.modalForm.resetValidation();
        }
      });
    },

    // Delete modal methods
    openDeleteModal(item, section) {
      if (section === "explanation" && this.userInfo.user_type === "สป.อว.") {
        return;
      }

      let modalText = "";

      if (section === "responsible") {
        const count = this.getRspTakers(item).length;
        modalText = count > 0 ? `ข้อมูลผู้รับผิดชอบ (${count} คน)` : "ข้อมูลผู้รับผิดชอบ";
      } else if (section === "explanation") {
        modalText = "คำชี้แจง";
      } else if (section === "explanation_sp") {
        modalText = "คำชี้แจง สป.อว.";
      }

      this.$store.commit("General/setModal", {
        theme: "delete",
        title: "ลบข้อมูล?",
        text: `คุณต้องการลบ${modalText} ใช่หรือไม่?`,
        buttonText: "ยืนยัน",
        cancelText: "ยกเลิก",
        action: async () => {
          let payload = {
            id: item.id,
            type: item.type || "C",
          };

          if (section === "responsible") {
            payload.progress_month_takers = [];
          } else if (section === "explanation") {
            payload.progress_month_remark = null;
          } else if (section === "explanation_sp") {
            payload.progress_month_remark_sp = null;
          }

          try {
            let res = await this.$apiFire(
              "MonthlyProgress/updateProgressData",
              payload
            );

            if (res) {
              if (section === "responsible") {
                this.$set(item, "progress_month_takers", []);
              } else if (section === "explanation") {
                this.$set(item, "progress_month_remark", null);
              } else if (section === "explanation_sp") {
                this.$set(item, "progress_month_remark_sp", null);
              }

              this.$store.commit("General/setModal", {
                title: "เสร็จสิ้น!",
                theme: "success",
                text: "ลบข้อมูลสำเร็จ",
                showCancel: false,
              });
            }
          } catch (error) {
            console.error("Error deleting progress data:", error);
            this.$store.commit("General/setModal", {
              title: "เกิดข้อผิดพลาด!",
              theme: "error",
              text: "ไม่สามารถลบข้อมูลได้",
              showCancel: false,
            });
          }
        },
      });
    },

    // Modal helper methods
    getModalTitle() {
      const { section, type } = this.modalData;
      if (section === "responsible") return "ผู้รับผิดชอบ";
      if (section === "explanation") {
        return type === "add" ? "เพิ่มคำชี้แจง" : "แก้ไขคำชี้แจง";
      }
      return "จัดการข้อมูล";
    },

    getModalSubtitle() {
      const { section } = this.modalData;
      if (section === "responsible") return "รายละเอียดผู้รับผิดชอบ";
      return "";
    },

    addResponsibleRow() {
      this.modalData.responsibleList.push({ taker: "", hours: "" });
    },

    removeResponsibleRow(idx) {
      this.modalData.responsibleList.splice(idx, 1);
    },

    expandAll() {
      this.regionExpanded = this.regions.map(() => true);
    },

    collapseAll() {
      this.regionExpanded = this.regions.map(() => false);
    },

    toggleRegion(index) {
      this.$set(this.regionExpanded, index, !this.regionExpanded[index]);
    },

    isExtendedMonth(monthIndex) {
      return monthIndex >= 12;
    },

    // Team management methods
    delTeam(index) {
      this.teams.splice(index, 1);
    },

    setTeamField(field, index, value) {
      if (!this.teams[index]) {
        this.$set(this.teams, index, {});
      }
      this.$set(this.teams[index], field, value);
    },
  },
};
</script>

<style scoped lang="scss">
.modal-field-label {
  color: #717579;
  font-size: 14px;
  font-weight: 400;
}

.plan-card {
  background: #ffffff;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  min-width: max-content;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}

.chart-container {
  padding: 10px;
}
.custom-legend {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.custom-legend span {
  display: flex;
  padding: 3px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 20px;
  color: #fff;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  transition: background 0.2s;
}
.legend-inactive {
  text-decoration: line-through;
}
.custom-selectbox-chart {
  width: 100%;
  max-width: 180px;
  border: 1px solid var(--theme-color-seven);
}

.text-underline {
  text-decoration: underline;
}

.cursor-pointer {
  cursor: pointer;
}

/* Modal specific styles removed - no longer needed */

.btn_gradient {
  background: linear-gradient(21.01deg, #f15a29 6.18%, #fbb040 84.83%);
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
  border-radius: 30px;
}

/* Progress Followed specific styles */
.progress-followed-add-field {
  font-size: 11px;
  padding: 3px 2px !important;
  border-radius: 8px;
  background: var(--theme-color-one);
  color: white;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.rotate180 {
  transform: rotate(180deg);
  transition: transform 0.2s ease;
}

.text-theme-1 {
  color: var(--theme-color-one);
}

.border-right-field {
  border-right: 3px solid var(--theme-color-seven);
}

/* Extended month background styles */
.extended-month-bg {
  position: relative;
}

.extended-month-header {
  position: relative;
  isolation: isolate;
}

.extended-month-header::before {
  content: '';
  position: absolute;
  inset: 0;
  left: -4px;
  right: -4px;
  background: linear-gradient(to top, rgba(241, 90, 41, 0.15), transparent);
  z-index: -1;
}

.extended-month-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: -4px;
  right: -4px;
  height: 3px;
  background-color: #f15a29;
  z-index: -1;
}

.extended-month-cell {
  background-color: rgba(241, 90, 41, 0.19) !important;
  border: 1px solid #F15A29;
}

.correct-range-cell {
  background-color: #ffffff !important;
  border: 1px solid #ff9800;
}
</style>
